import { render, staticRenderFns } from "./WritingData.vue?vue&type=template&id=e1629910&scoped=true"
import script from "./WritingData.vue?vue&type=script&lang=ts"
export * from "./WritingData.vue?vue&type=script&lang=ts"
import style0 from "./WritingData.vue?vue&type=style&index=0&id=e1629910&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1629910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1629910')) {
      api.createRecord('e1629910', component.options)
    } else {
      api.reload('e1629910', component.options)
    }
    module.hot.accept("./WritingData.vue?vue&type=template&id=e1629910&scoped=true", function () {
      api.rerender('e1629910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/WritingData.vue"
export default component.exports